import React, { JSX } from 'react'
import { useLocation, useParams } from 'react-router'
import { QuickOverlayManagerView } from 'components/chatOverlays/ChatOverlayManager'
import { EmoteWallManager } from 'components/chatOverlays/EmoteWallManager'
import { useEventDetail } from 'hooks/useEventDetail'
import { eventSectionPath } from 'lib/paths'

export const EmoteWallsPage = (): JSX.Element => {
  const { eventId = '', emoteWallId } = useParams<{ eventId: string, emoteWallId: string }>()
  const { pathname } = useLocation()
  const { event, refetchEvent, setEvent } = useEventDetail()
  const basePath = eventSectionPath(eventId, 'emote-walls')
  let view: QuickOverlayManagerView = 'list'
  if (pathname.endsWith('/new')) view = 'create'
  else if (emoteWallId !== undefined) view = { edit: emoteWallId }
  return (
    <EmoteWallManager
      view={view}
      basePath={basePath}
      backLabel='Back to emote walls'
      scope={{ kind: 'stream', event, refetchEvent, setEvent }}
    />
  )
}
